(function () {
  const modal = document.getElementById('SearchModal');
  if (!modal) return;

  const input    = modal.querySelector('input[type="search"]');
  const resetBtn = modal.querySelector('.pill-reset');

  let scrollY = 0;

  function lockBody() {
    scrollY = window.scrollY || window.pageYOffset || 0;

    const sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) {
      document.documentElement.style.setProperty('--scrollbar-comp', sbw + 'px');
      document.body.style.paddingRight = `var(--scrollbar-comp)`;
    }

    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('is-fixed');
    document.body.style.top = `-${scrollY}px`;
  }

  function unlockBody() {
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('is-fixed');

    document.body.style.top = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.removeProperty('--scrollbar-comp');

    window.scrollTo(0, scrollY);
  }

  function togglePresets() {
    const hasText = !!(input && input.value.trim().length);
    modal.classList.toggle('showing-presets', !hasText);
  }

  function openModal() {
    modal.setAttribute('open', '');
    lockBody();
    togglePresets();
    setTimeout(() => input && input.focus(), 0);
  }

  function closeModal() {
    modal.removeAttribute('open');
    unlockBody();
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  document.querySelectorAll('[data-open-search]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.preventDefault(); openModal(); });
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); }
    });
  });

  modal.querySelectorAll('[data-search-close], .search-modal__overlay').forEach(el => {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

  
  input && input.addEventListener('input', togglePresets);
  resetBtn && resetBtn.addEventListener('click', () => {
    input.value = '';
    togglePresets();
    input.focus();
  });

  togglePresets();
})();